import Vue from 'vue';
import { GlobalState } from '../global-state/global-state';
import { AddToSamplesButton } from '../components/product-samples/add-to-samples-button-component';
import ProductSamplesClass from '../components/product-samples/product-samples';

export default () => {
  const sections = document.querySelectorAll('.product-tiles');
  if (!sections.length) return;

  sections.forEach((el) => {
    if (!el.id) el.id = `product-tiles-${Math.random().toString(36).slice(2, 8)}`;
    new Vue({
      el: `#${el.id}`,
      components: {
        'add-to-samples': AddToSamplesButton,
      },
      data: {
        sharedState: GlobalState.state,
        productSampleClass: null,
        ctaButtonIsEnabled: true,
      },
      beforeMount() {
        this.productSampleClass = new ProductSamplesClass(this);
      },
      methods: {
        ctaButtonClick() {},
      },
    });
  });
};
